export const houseSitterStatuses = [
    { option: "single", label: "Single" },
    { option: "couple", label: "Couple" },
    { option: "family", label: "Family" },
]